/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import PdSpecialRequestsIcon from 'icons/PdSpecialRequestsIcon';

const messages = defineMessages({
  title: {
    id: 'navigation.pd-special-request',
    defaultMessage: 'PD Special Requests',
  },
});

const PdSpecialRequestsItem = () => (
  <RouteLinkItem
    iconBefore={PdSpecialRequestsIcon}
    route="midas/staff/pd-special-requests"
    title={messages.title}
  />
);

export default PdSpecialRequestsItem;
